import { createI18n } from "vue-i18n";
import locales from "../locales/index";

const i18n = createI18n({
  legacy: false,
  locale: "de",
  globalInjection: true,
  fallbackLocale: "en",
  messages: locales,
  pluralRules: {
    sl: (choice) => {
      const category = new Intl.PluralRules("sl").select(choice);
      return ["one", "two", "few", "other"].indexOf(category);
    },
  },
});

export default i18n;
